import { createFileRoute } from '@tanstack/react-router';

import Actings from '@/modules/actings/pages/Actings';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/actings/',
)({
  head: () => ({
    meta: [{ title: 'Execuções de Rotas' }],
  }),
  component: Actings,
});
